import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'

import style from './style.css'

class SavingIndicator extends React.Component {
    
  render() {
    const { scenarioSave, id } = this.props
    const info = scenarioSave && id && scenarioSave[id]
    let cn
    if ( info ) {
      if ( info.error ) {
        cn = classnames( 'fa fa-exclamation-circle fa-fw', style.errorIndicator, style.savingIndicator )
      } else if ( info.saving ) {
        cn = classnames( 'fa fa-spin fa-refresh fa-fw', style.savingIndicator, style.savingIndicator )
      } else {
        cn = classnames( 'fa fa-check fa-fw', style.savedIndicator, style.savingIndicator )
      }
    } else {
      cn = 'fa'
      cn = classnames( 'fa fa-check fa-fw', style.savedIndicator, style.savingIndicator )

    }

    return (
      <div><i className={cn} /></div> );
  }

}

export default connect(
  state => ( {
    scenarioSave : state.scenarioSave
  } )
)( SavingIndicator );
